import {
  Box,
  Button,
  CircularProgress,
  createTheme,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import { Text, View, TextInput } from "react-native";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header";
import {
  getAllAnalyst,
  getAllMatches,
  getAllOrganizer,
} from "../../redux/actions/adminAction";
import { Link } from "react-router-dom";
import EditDialog from "./EditDialog";
import { MatchCard } from "./MatchCard";
import { useInfiniteQuery, useQueryClient, useQuery } from "react-query";
import axios from "axios";
import { MAIN_API } from "../../config/stepoutAPI";
import { useInView } from "react-intersection-observer";
import SimpleButton from "../../components/SimpleButton";
import Select from "react-select";
import Multiselect from "multiselect-react-dropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVDownload, CSVLink } from "react-csv";
import "./style.css";
import {
  CloseOutlined,
  DownloadSharp,
  FilterList,
  SearchOutlined,
  Sort,
} from "@mui/icons-material";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";

const CustomDateInput = forwardRef(({ value, onClick, className }, ref) => (
  <Button
    className={className}
    onClick={onClick}
    ref={ref}
    sx={{
      height: "40px",
      fontSize: "12px",
      border: "1px solid #f1f1f1",
      borderRadius: "4px",
      color: "#12121370",
      textTransform: "none",
      fontWeight: "400",
    }}
  >
    {value || "Select Date"}
  </Button>
));

export const ManagementScreen = () => {
  const multiselectRefAnalyzed = useRef(null);
  const multiselectRefAnalyst = useRef(null);
  const [openEdit, setOpenEdit] = React.useState({ data: null, show: false });

  const [searchMatchId, setSearchMatchId] = useState();
  const [searchByAnalyzed, setSearchByAnalyzed] = useState();
  const [selectAnalyzedArray, setSelectAnalyzedArray] = useState();
  const [searchByAnalyst, setSearchByAnalyst] = useState();
  const [selectAnalystArray, setSelectedAnalystArray] = useState();
  const [assignDate, setAssignDate] = useState();
  const [dueDate, setDueDate] = useState();
  const [sortBy, setSortBy] = useState();
  const [searchClicked, setSearchClicked] = useState(false);
  const [filterShown, setFilterShown] = useState(false);
  // const [searchByReviwer , setSearchByReviewer] = useState();
  const [selectedReviewerArray, setSelectedReviewerArray] = useState();
  const [csvData, setCsvData] = useState([]);
  const [downloadReady, setDownloadReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize] = useState(20);
  const [pageLinks, setPageLinks] = useState([]);
  const [currentOffset, setCurrentOffset] = useState(0);

  const { fetchingMatches } = useSelector((state) => state.admin);
  const { token, isAdmin } = useSelector((state) => state.auth);

  const [matches, setMatches] = useState([]);

  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  const handleRefetch = async () => {
    await queryClient.invalidateQueries(["allMatches"]); // Force cache reset
    await refetch(); // Fetch fresh data
  };

  const { ref, inView } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (downloadReady) {
      setDownloadReady(false); // prevent future auto-triggers
    }
  }, [downloadReady]);

  const getDownloadData = async () => {
    const today = new Date();

    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(today.getMonth() - 1);

    const formatDate = (date) => {
      return date.toISOString().split("T")[0];
    };

    const start_date = formatDate(oneMonthAgo);
    const end_date = formatDate(today);

    try {
      const { data } = await axios({
        method: "POST",
        url: `${MAIN_API}getAllMatches/v2/`,
        data: {
          source: "analyst_portal",
          start_date: start_date,
          end_date: end_date,
        },
        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "application/json",
        },
      });

      return data?.response_data?.data;
    } catch (error) {
      throw error;
    }
  };

  const getStatusLabel = (statusValue) => {
    const found = analysisOptions.find(
      (option) => option.value === statusValue
    );
    return found ? found.label : "NA";
  };

  const formatTimeFromSecondsToMinutes = (seconds) => {
    const mins = Math.floor(seconds / 60);
    return `${mins} mins`;
  };

  const transformDataForCSV = (rawMatches) => {
    return rawMatches.map((match) => ({
      "Match ID": match.id,
      "Match Details": `${match.team_a_details?.name} vs ${match.team_b_details?.name}`,
      Analysts: match.analyst_details.map((a) => a.name).join(", "),
      "Assign Date": match.analysis_sense_data?.assigned_date || "NA",
      "Start Time": match.analysis_sense_data?.analysis_start_time || "NA",
      Progress: match.progress ?? "NA",
      "End Time": match.analysis_sense_data?.analysis_end_time || "NA",
      "Current Analysis Time":
        match.analysis_sense_data?.current_analysis_time || "NA",
      "Due date": match.analysis_sense_data?.due_date || "NA",
      Status: getStatusLabel(match.status),
      Reviewers:
        match.reviewer_details?.map((item) => item.name).join(", ") || "NA",
      "Account Availablity":
        match.organizer_details?.map((item) => item.id).join(", ") || "NA",
      "Analysis TAT": match.analysis_tat ?? "NA",
      "Overall TAT": match.overall_tat ?? "NA",
      "Game Time": match.game_time != null ? `${match.game_time} mins` : "NA",
      "Total Video time": match.youtube_videos?.[0]?.total_video_duration
        ? formatTimeFromSecondsToMinutes(
            match.youtube_videos[0].total_video_duration
          )
        : "NA",
    }));
  };

  const fetchDataAndDownload = async () => {
    setLoading(true);
    try {
      const rawData = await getDownloadData();
      const transformedData = transformDataForCSV(rawData);
      setCsvData(transformedData);
      setDownloadReady(true);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setLoading(false);
    }
  };

  // to invalidate tags for component umnount
  useEffect(() => {
    return () => {
      queryClient.removeQueries(["allMatches"]);
    };
  }, [queryClient]);

  const analysisOptions = [
    { value: 1, label: "Match Created" },
    { value: 2, label: "Video Uploaded" },
    { value: 3, label: "Analysis Done" },
    { value: 4, label: "Resources Assigned" },
    { value: 5, label: "Analysis In Progress" },
    { value: 6, label: "Review In Progress" },
    { value: 7, label: "Completed" },
    { value: 8, label: "Mark for Review" },
    { value: 9, label: "Issue Found" },
  ];

  useEffect(() => {
    if (token) {
      dispatch(getAllAnalyst({ token }));
      dispatch(getAllOrganizer({ token }));
    }
  }, [token, dispatch]);

  const allAnalyst = useSelector((state) => state.admin.allAnalyst);

  const _getAllMatches = useCallback(async () => {
    try {
      const { data } = await axios({
        method: "POST",
        url: `${MAIN_API}getAllMatches/v2/?offset=${currentOffset}&limit=${pageSize}`,
        data: {
          source: "analyst_portal",
          id: searchMatchId ? parseInt(searchMatchId) : null,
          analyst_list: selectAnalystArray,
          reviewer_list: selectedReviewerArray,
          analysis_status: selectAnalyzedArray,
          due_date: dueDate ? moment(dueDate).format("YYYY-MM-DD") : null,
          assigned_date: assignDate
            ? moment(assignDate).format("YYYY-MM-DD")
            : null,
          order: sortBy ? sortBy.value : null,
        },
        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "application/json",
        },
      });
      setTotalPages(
        Math.ceil((data?.response_data?.data?.count || 1) / pageSize)
      );
      setPageLinks(data?.response_data?.data?.links || []);
      // Find current page from links
      const current = (data?.response_data?.data?.links || []).find(
        (l) => l.is_current
      );
      setCurrentPage(current ? current.counter : 1);
      return data?.response_data?.data;
    } catch (error) {
      throw error;
    }
  }, [
    selectAnalystArray,
    selectedReviewerArray,
    selectAnalyzedArray,
    dueDate,
    searchMatchId,
    assignDate,
    sortBy,
    currentOffset,
    pageSize,
    token,
  ]);

  const {
    data: _allMatches,
    isLoading: isLoadingMatches,
    refetch,
    isRefetching,
    isFetched,
  } = useQuery(
    [
      "allMatches",
      currentOffset,
      // selectAnalystArray,
      // selectedReviewerArray,
      // selectAnalyzedArray,
      // dueDate,
      // searchMatchId,
      // assignDate,
      // sortBy,
    ],
    _getAllMatches,
    {
      refetchOnWindowFocus: false, // 5 minutes
      enabled: !!token,
    }
  );

  const sortByOptions = [
    { value: "asc", label: "Ascending" },
    { value: "desc", label: "Descending" },
  ];

  const handleReset = () => {
    setSearchMatchId("");
    setAssignDate("");
    setDueDate("");
    setSelectedAnalystArray([]);
    setSelectAnalyzedArray([]);

    if (multiselectRefAnalyst.current) {
      multiselectRefAnalyst.current.resetSelectedValues();
    }
    if (multiselectRefAnalyzed.current) {
      multiselectRefAnalyzed.current.resetSelectedValues();
    }
    setTimeout(() => {
      handleRefetch();
    }, 500);
  };

  const handleSortReset = () => {
    setSortBy("");
    setTimeout(() => {
      handleRefetch();
    }, 500);
  };

  const handleSearch = () => {
    setSearchClicked(true);
    setTimeout(() => {
      handleRefetch();
    }, 500);
  };

  const handleSortSelect = () => {
    setSearchClicked(true);
    setTimeout(() => {
      handleRefetch();
    }, 500);
  };

  useEffect(() => {
    if (!isRefetching) {
      setSearchClicked(false);
    }
  }, [isRefetching]);

  // useEffect(() => {
  //   const setAnalyst = () => {
  //     const analystIdsAndNames = _allMatches?.pages
  //       ?.flatMap((item) =>
  //         item?.data?.flatMap((analyst) =>
  //           analyst.analyst_details.map((details) => ({
  //             id: details.id,
  //             name: details.name,
  //           }))
  //         )
  //       )
  //       .filter(
  //         (obj, index, self) => index === self.findIndex((o) => o.id === obj.id)
  //       );
  //     setSearchByAnalyst(analystIdsAndNames);
  //   };
  //   setAnalyst();
  // }, [!isLoadingMatches]);

  useEffect(() => {
    const setAnalyst = () => {
      const analystIdsAndNames = allAnalyst
        ?.map((analyst) => ({
          id: analyst.id,
          name: analyst.name,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
      setSearchByAnalyst(analystIdsAndNames);
    };

    setAnalyst();
  }, [allAnalyst]);

  //   useEffect(() => {
  //  const setReviewer = () => {
  //       const reviewerIdsAndNames = _allMatches?.pages
  //         ?.flatMap((item) =>
  //           item?.data?.flatMap((reviewer) =>
  //             reviewer.reviewer_details.map((details) => ({
  //               id: details.id,
  //               name: details.name,
  //             }))
  //           )
  //         )
  //         .filter(
  //           (obj, index, self) => index === self.findIndex((o) => o.id === obj.id)
  //         );
  //       setSearchByReviewer(reviewerIdsAndNames);
  //       console.log(_allMatches);

  //     };
  //     setReviewer();
  //   } , [_allMatches]);

  const ListHeader = () => (
    <TableHead
      sx={{ backgroundColor: "#121213", position: "sticky", zIndex: 999 }}
    >
      <TableRow
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
        }}
      >
        <TableCell
          sx={{
            position: "sticky",
            left: 0,
            zIndex: 999,
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          component="th"
          scope="row"
        >
          Match ID
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Match Details
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Analysts
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
              minWidth: "100px",
            },
          }}
          align="left"
        >
          Assign Date
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
              minWidth: "100px",
            },
          }}
          align="left"
        >
          Start Time
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Progress
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
              minWidth: "100px",
            },
          }}
          align="right"
        >
          End Time
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "100%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Current Analysis Time
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
              minWidth: "100px",
            },
          }}
          align="right"
        >
          Due date
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Status
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Reviewers
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Account Availablity
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Analysis TAT
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Overall TAT
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Game Time
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Total Video Time
        </TableCell>
        <TableCell
          colSpan={2}
          sx={{
            fontSize: {
              lg: "12px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",

              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );

  if (fetchingMatches || isLoadingMatches) {
    return (
      <Grid
        container
        display="flex"
        flexDirection="column"
        height="80vh"
        justifyContent="center"
        alignItems="center"
      >
        <Typography sx={{ my: 5 }}>Loading Match List</Typography>
        <CircularProgress color="primary" />
      </Grid>
    );
  }

  if (!isAdmin) {
    return (
      <Grid container>
        <Header label="Admin Portal" tab="management" />
        <Grid item lg={12} sx={{ paddingY: 10, paddingX: 10 }}>
          <Link to="/home">Back to home</Link>
        </Grid>
      </Grid>
    );
  }

  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          root: {
            minWidth: "50px",
          },
        },
      },
    },
  });

  return (
    <Grid container sx={{ overflow: "hidden" }}>
      <Header label="Admin Portal" tab="management" />

      <EditDialog
        open={openEdit.show}
        data={openEdit.data}
        handleClose={() => setOpenEdit({ show: false, data: null })}
        refreshData={refetch}
      />

      <Stack
        sx={{
          paddingY: 4,
          paddingX: 0,
          overflow: "auto",
          height: "85vh",
          width: "100%",
        }}
      >
        <Stack sx={{ width: "100%", zIndex: 999999999 }}>
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              zIndex: 20,
              marginTop: 0,
              justifyContent: "space-between",
              alignItems: "center",
              zIndex: 99999999,
              paddingHorizontal: "5px",
            }}
          >
            <View style={{ flex: 1 }}>
              <Text style={{ marginBottom: "0.8em" }}>Sort Match ID :</Text>
              <Stack
                direction="row"
                spacing={1}
                justifyContent="flex-start"
                alignItems={"center"}
                flexWrap="wrap"
                flex={1}
                gap={0.5}
              >
                <Select
                  value={sortBy}
                  onChange={(val) => {
                    setSortBy(val);
                  }}
                  options={sortByOptions}
                  isSearchable={false}
                />
                <Button
                  onClick={() => {
                    handleSortReset();
                  }}
                  size="small"
                  variant="outlined"
                  color="secondary"
                  sx={{
                    textTransform: "none",
                  }}
                  startIcon={
                    <CloseOutlined color="#12121280" fontSize="12px" />
                  }
                >
                  Reset
                </Button>
                <Button
                  onClick={() => {
                    handleSortSelect();
                  }}
                  size="small"
                  variant="outlined"
                  color="secondary"
                  sx={{
                    textTransform: "none",
                  }}
                  startIcon={<Sort color="#12121280" fontSize="12px" />}
                >
                  Sort
                </Button>
                <div>
                  <Button
                    variant="contained"
                    startIcon={<DownloadSharp />}
                    size="small"
                    disabled={loading}
                    onClick={fetchDataAndDownload}
                  >
                    {loading ? "Downloading..." : "Download CSV"}
                  </Button>

                  {downloadReady && (
                    <CSVDownload
                      data={csvData}
                      filename={"1_month_data.csv"}
                      target="_blank"
                    />
                  )}
                </div>
              </Stack>
            </View>
            <Tooltip title={`${filterShown ? "Hide" : "Show"} search/filter`}>
              <Stack
                gap={1}
                direction="row"
                alignItems="center"
                justifyContent="center"
              >
                {filterShown && (
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    Hide Filters
                  </Typography>
                )}
                <IconButton
                  onClick={() => setFilterShown(!filterShown)}
                  sx={{
                    fontSize: "16px",
                    backgroundColor: "orange",
                    color: "#fff",
                    ":hover": {
                      backgroundColor: "darkorange",
                    },
                  }}
                >
                  {filterShown ? <CloseOutlined /> : <FilterList />}
                </IconButton>
              </Stack>
            </Tooltip>
          </View>

          {filterShown && (
            <Stack sx={{ px: "5px" }}>
              <Stack
                sx={{
                  width: "100%",
                  flexDirection: "row",
                  zIndex: 10,
                  marginTop: "1em",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                <View>
                  <Text>Search by Match Id</Text>
                  <TextInput
                    style={{
                      marginTop: "0.8em",
                      height: 40,
                      borderColor: "#f1f1f1",
                      borderWidth: 1,
                      marginBottom: 10,
                      paddingHorizontal: 10,
                      borderRadius: 4,
                    }}
                    placeholder="Enter Match id"
                    keyboardType="numeric"
                    value={searchMatchId}
                    onChangeText={(text) => {
                      setSearchMatchId(text);
                      setSearchClicked(false);
                    }}
                  />
                </View>
                <View
                  style={{
                    width: 1,
                    marginVertical: "0.5em",
                    backgroundColor: "#f1f1f1",
                    marginHorizontal: "1em",
                  }}
                />
                <View style={{ zIndex: 9999 }}>
                  <Text style={{ marginBottom: "0.8em" }}>
                    Search by Analysts
                  </Text>
                  <Multiselect
                    ref={multiselectRefAnalyst}
                    displayValue="name"
                    showCheckbox
                    onSearch={function noRefCheck() {}}
                    onKeyPressFn={function noRefCheck() {}}
                    onRemove={(list) => {
                      setSelectedAnalystArray(list.map((i) => i.id));
                    }}
                    onSelect={(value) => {
                      setSelectedAnalystArray(value.map((i) => i.id));
                    }}
                    options={searchByAnalyst}
                    style={{
                      option: {
                        fontSize: "10px",
                        fontWeight: "600",
                      },
                      searchBox: {
                        fontSize: "10px",
                        minHeight: "39px",
                        maxHeight: "59px",
                        minWidth: "180px",
                        borderColor: "#f1f1f1",
                      },
                    }}
                  />
                </View>
                {/* new code */}
                <View
                  style={{
                    width: 1,
                    marginVertical: "0.5em",
                    backgroundColor: "#f1f1f1",
                    marginHorizontal: "1em",
                  }}
                />
                <View style={{ zIndex: 9999 }}>
                  <Text style={{ marginBottom: "0.8em" }}>
                    Search by Reviewer
                  </Text>
                  <Multiselect
                    ref={multiselectRefAnalyst}
                    displayValue="name"
                    showCheckbox
                    onSearch={function noRefCheck() {}}
                    onKeyPressFn={function noRefCheck() {}}
                    onRemove={(list) => {
                      setSelectedReviewerArray(list.map((i) => i.id));
                    }}
                    onSelect={(value) => {
                      setSelectedReviewerArray(value.map((i) => i.id));
                    }}
                    options={searchByAnalyst}
                    style={{
                      option: {
                        fontSize: "10px",
                        fontWeight: "600",
                      },
                      searchBox: {
                        fontSize: "10px",
                        minHeight: "39px",
                        maxHeight: "59px",
                        minWidth: "180px",
                        borderColor: "#f1f1f1",
                      },
                    }}
                  />
                </View>
                {/* end code */}
                <View
                  style={{
                    width: 1,
                    marginVertical: "0.5em",
                    backgroundColor: "#f1f1f1",
                    marginHorizontal: "1em",
                  }}
                />
                <View style={{ zIndex: 9999 }}>
                  <Text style={{ marginBottom: "0.8em" }}>
                    Search by Analyze Status{" "}
                  </Text>

                  <Multiselect
                    ref={multiselectRefAnalyzed}
                    displayValue="label"
                    showCheckbox
                    onKeyPressFn={function noRefCheck() {}}
                    onRemove={(list) => {
                      setSelectAnalyzedArray(list.map((i) => i.value));
                    }}
                    onSearch={function noRefCheck() {}}
                    options={analysisOptions}
                    onSelect={(value) => {
                      setSelectAnalyzedArray(value.map((i) => i.value));
                    }}
                    style={{
                      option: {
                        fontSize: "10px",
                        fontWeight: "600",
                      },
                      searchBox: {
                        fontSize: "10px",
                        minHeight: "39px",
                        maxHeight: "59px",
                        minWidth: "180px",
                        borderColor: "#f1f1f1",
                      },
                    }}
                  />
                </View>
                <View
                  style={{
                    width: 1,
                    marginVertical: "0.5em",
                    backgroundColor: "#f1f1f1",
                    marginHorizontal: "1em",
                  }}
                />
                <View>
                  <Text style={{ marginBottom: "0.8em" }}>Assign date </Text>
                  <DatePicker
                    selected={assignDate}
                    onChange={(date) => setAssignDate(date)}
                    className="custom-datepicker"
                    customInput={<CustomDateInput className="" />}
                  />
                </View>
                <View style={{ marginStart: "1em" }}>
                  <Text style={{ marginBottom: "0.8em" }}>Due Date </Text>
                  <DatePicker
                    selected={dueDate}
                    onChange={(date) => setDueDate(date)}
                    customInput={<CustomDateInput className="" />}
                  />
                </View>
              </Stack>
              <Stack
                sx={{
                  flex: 1,
                  gap: 2,
                  marginTop: 2,
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Button
                  onClick={() => {
                    handleReset();
                  }}
                  size="small"
                  variant="outlined"
                  color="secondary"
                  sx={{
                    textTransform: "none",
                  }}
                  startIcon={
                    <CloseOutlined color="#12121280" fontSize="12px" />
                  }
                >
                  Reset
                </Button>

                <Button
                  onClick={() => {
                    handleSearch();
                  }}
                  size="small"
                  variant="contained"
                  color="primary"
                  sx={{
                    textTransform: "none",
                  }}
                  startIcon={
                    <SearchOutlined color="#12121280" fontSize="12px" />
                  }
                >
                  Search
                </Button>
              </Stack>
            </Stack>
          )}
        </Stack>
        <Box sx={{ paddingX: "5px", mt: 1 }}>
          <ThemeProvider theme={theme}>
            {(searchClicked || isRefetching) && (
              <LinearProgress
                variant="indeterminate"
                sx={{ width: "100%", height: 4, mt: 1 }}
              />
            )}
            <TableContainer
              sx={{
                position: "relative",

                overflow: "auto",
                maxHeight: "85vh",
                zIndex: 99,
              }}
              component={Paper}
            >
              <Table
                stickyHeader
                size="small"
                sx={{ borderSpacing: "0px 0px", borderCollapse: "separate" }}
              >
                <ListHeader />

                {searchClicked || isRefetching ? (
                  <div
                    style={{
                      width: "100vw",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "1rem",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <TableBody sx={{ paddingBottom: "50px" }}>
                    {_allMatches?.data?.map((i) => (
                      <MatchCard
                        key={i?.id}
                        data={i}
                        onEditPress={() => {
                          setOpenEdit({ data: i, show: true });
                        }}
                      />
                    ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ mt: 2 }}
            >
              {pageLinks.length > 1 && (
                <Pagination
                  count={pageLinks.length}
                  page={pageLinks.findIndex((l) => l.is_current) + 1}
                  onChange={(event, value) => {
                    const link = pageLinks[value - 1];
                    if (link) {
                      setCurrentPage(link.counter);
                      setCurrentOffset(
                        Number(link.params.match(/offset=(\d+)/)?.[1] || 0)
                      );
                    }
                  }}
                  color="primary"
                  shape="rounded"
                  size="small"
                  renderItem={(item) => {
                    const link = pageLinks[item.page - 1];
                    return (
                      <PaginationItem
                        {...item}
                        page={link ? link.counter : item.page}
                        selected={link ? link.is_current : false}
                      />
                    );
                  }}
                />
              )}
            </Stack>
          </ThemeProvider>
        </Box>
      </Stack>
    </Grid>
  );
};
